import React from 'react';

const TrashX: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    height="21"
    fill="none"
    viewBox="0 0 21 21"
    width="21"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d={`M11.8477 1.50879C12.2073 1.54446 12.5485 1.68603 12.8281 1.91504L12.9629
      2.03711L13.085 2.17188C13.352 2.49797 13.4999 2.90782 13.5 3.33301V4.83301H16.666L16.7686
      4.83789C17.2727 4.88906 17.6659 5.31537 17.666 5.83301C17.666 6.35079 17.2728 6.77694
      16.7686 6.82812H16.7539L15.9971 15.916L15.9951 15.915C15.9743 16.5922 15.7001 17.2381
      15.2197 17.7188C14.7198 18.2187 14.041 18.4998 13.334 18.5H6.66699C5.95975 18.5 5.28135
      18.2188 4.78125 17.7188C4.30077 17.2383 4.02499 16.5931 4.00391 15.916L3.24609
      6.82812C2.73472 6.78387 2.33301 6.35586 2.33301 5.83301C2.33318 5.28098 2.78098 4.83318
      3.33301 4.83301H6.5V3.33301C6.50009 2.84689 6.69337 2.38085 7.03711 2.03711L7.17188
      1.91504C7.49797 1.64798 7.90782 1.50008 8.33301 1.5H11.667L11.8477 1.50879ZM5.99707
      15.75L6 15.833C6 16.0098 6.07029 16.1797 6.19531 16.3047C6.32034 16.4297 6.49018 16.5
      6.66699 16.5H13.334C13.5104 16.4998 13.6798 16.4294 13.8047 16.3047C13.9295 16.1797
      14 16.0097 14 15.833L14.0039 15.75L14.7471 6.83301H5.25293L5.99707 15.75ZM10.959
      9.29297C11.3494 8.90255 11.9825 8.90277 12.373 9.29297C12.7636 9.68349 12.7636 10.3165
      12.373 10.707L11.4131 11.666L12.373 12.626L12.4424 12.7021C12.7626 13.0949 12.7391 13.674
      12.373 14.04C12.007 14.406 11.4279 14.4296 11.0352 14.1094L10.959 14.04L9.99902
      13.0801L9.04004 14.04C8.6495 14.4304 8.01645 14.4305 7.62598 14.04C7.23583 13.6495 7.23572
      13.0164 7.62598 12.626L8.58496 11.666L7.62598 10.707L7.55762 10.6309C7.23745 10.2381
      7.26007 9.65904 7.62598 9.29297C7.99203 8.92691 8.5711 8.90443 8.96387 9.22461L9.04004
      9.29297L9.99902 10.252L10.959 9.29297ZM8.5 4.83301H11.5V3.5H8.5V4.83301Z`} fill="#98A2B3"/>
  </svg>
);

export default TrashX;
